import {InformationKeys} from 'shared/types/information-keys';

export type InformationKeysProps<T = any> =
  | InformationKeys<T>
  | keyof typeof informationProps;

export const informationProps = {};
